import React, { Component } from 'react';
import { string, oneOf, bool } from 'prop-types';
import cx from 'classnames';

import { Icon } from '../';

const CLASS_ROOT = 'btn';

class Button extends Component {
  static propTypes = {
    type: string,
    link: oneOf(['link']),
    href: string,
    size: oneOf(['small', 'large']),
    spinner: bool,
  };

  render() {
    const {
      className,
      children,
      type,
      tag = 'button',
      href,
      size,
      spinner,
      ...other
    } = this.props;

    let Tag = tag;

    if (href) {
      Tag = 'a';
    }

    const classes = cx(
      CLASS_ROOT,
      {
        [`${CLASS_ROOT}--${type}`]: type,
        [`${CLASS_ROOT}--${size}`]: size,
        [`${CLASS_ROOT}--spinner`]: spinner,
      },
      className,
    );

    const props = {
      href,
      className: classes,
      disabled: spinner,
      ...other,
    };

    const returnChildren = spinner ? <Icon name="spinner" /> : children;

    return (
      <Tag type={type} {...props}>
        {returnChildren}
      </Tag>
    );
  }
}

export default Button;
